export default "/static/build/main-right-image.png";